var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "120px",
    viewBox: "0 0 200 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "large/discover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.4143743%",
    y1: "9.06316954%",
    x2: "88.6006499%",
    y2: "80.4988417%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69E35",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.8227729%",
    y1: "9.06316954%",
    x2: "85.5611257%",
    y2: "80.4988417%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F34F26",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69E35",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Large",
    transform: "translate(-32.000000, -3748.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "large/discover",
    transform: "translate(32.000000, 3748.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#F58220",
    x: 0,
    y: 0,
    width: 200,
    height: 120,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(20.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discover"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(70.625000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-2-link",
    fill: "url(#linearGradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8613303,0.118753276 C6.36687719,0.118753276 0.28644375,6.21853644 0.28644375,13.7468571 C0.28644375,21.7506722 6.10270344,27.7338925 13.8613303,27.7338925 C21.4262625,27.7338925 27.3992519,21.6715943 27.3992519,13.9039859 C27.3992519,6.18259193 21.4661844,0.118753276 13.8613303,0.118753276 Z",
    id: "path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-2-link",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8613303,0.118753276 C6.36687719,0.118753276 0.28644375,6.21853644 0.28644375,13.7468571 C0.28644375,21.7506722 6.10270344,27.7338925 13.8613303,27.7338925 C21.4262625,27.7338925 27.3992519,21.6715943 27.3992519,13.9039859 C27.3992519,6.18259193 21.4661844,0.118753276 13.8613303,0.118753276 Z",
    id: "path-2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.42052378,0.615814484 L0.122722531,0.615814484 L0.122722531,27.1356731 L7.38257347,27.1356731 C11.2342866,27.1356731 14.0199402,26.1846841 16.4635478,24.0757684 C19.3630525,21.5704362 21.0826465,17.7926683 21.0826465,13.8885811 C21.0826465,6.0588401 15.4684603,0.615814484 7.42052378,0.615814484 Z M13.2244616,20.5336938 C11.6551904,22.0089592 9.63495081,22.646204 6.42445053,22.646204 L5.09076713,22.646204 L5.09076713,5.10631061 L6.42445053,5.10631061 C9.63495081,5.10631061 11.5778111,5.70350294 13.2244616,7.2527113 C14.9415913,8.84351258 15.9657577,11.3067384 15.9657577,13.8505826 C15.9657577,16.3995618 14.9415913,18.9490545 13.2244616,20.5336938 Z M23.3744528,27.1356731 L28.3341187,27.1356731 L28.3341187,0.615814484 L23.3744528,0.615814484 L23.3744528,27.1356731 Z M40.4767494,10.788624 C37.4959225,9.63788622 36.6186288,8.87894358 36.6186288,7.45246007 C36.6186288,5.78104041 38.1805072,4.50963178 40.3214978,4.50963178 C41.8099397,4.50963178 43.0312506,5.14533607 44.3328981,6.65192451 L46.9248572,3.11857929 C44.7878094,1.16576547 42.2308434,0.173183532 39.44174,0.173183532 C34.9424066,0.173183532 31.5046972,3.43540446 31.5046972,7.7656908 C31.5046972,11.4274093 33.1064972,13.2944697 37.7645322,15.0485618 C39.7123209,15.7607765 40.7024797,16.2357575 41.1997772,16.5602851 C42.1919075,17.2365554 42.6901906,18.1875444 42.6901906,19.3002837 C42.6901906,21.4507923 41.0474828,23.0390261 38.8305919,23.0390261 C36.4638703,23.0390261 34.5574819,21.8076699 33.4115788,19.5015729 L30.209457,22.7263088 C32.4948563,26.2206287 35.243545,27.7765124 39.0262578,27.7765124 C44.1786325,27.7765124 47.8026434,24.1928448 47.8026434,19.0645904 C47.8026434,14.848813 46.1274072,12.9386191 40.4767494,10.788624 Z M49.3669863,13.8885811 C49.3669863,21.691107 55.246825,27.7338925 62.8063356,27.7338925 C64.9433834,27.7338925 66.7753497,27.293829 69.0296984,26.1846841 L69.0296984,20.0972248 C67.0419878,22.167115 65.2859219,23.0000006 63.0330519,23.0000006 C58.0339572,23.0000006 54.4819038,19.2212057 54.4819038,13.8505826 C54.4819038,8.76289416 58.1448506,4.74583854 62.8063356,4.74583854 C65.1691141,4.74583854 66.9660869,5.62031709 69.0296984,7.72769233 L69.0296984,1.64074648 C66.8542075,0.491035687 65.0572344,0.017595158 62.9196938,0.017595158 C55.3986262,0.017595158 49.3669863,6.18259193 49.3669863,13.8885811 Z M109.258046,18.4299131 L102.463456,0.615814484 L97.0429644,0.615814484 L107.848954,27.8129704 L110.518786,27.8129704 L121.513541,0.615814484 L116.132972,0.615814484 L109.258046,18.4299131 Z M123.770355,27.1356731 L137.853381,27.1356731 L137.853381,22.646204 L128.731992,22.646204 L128.731992,15.4829769 L137.504435,15.4829769 L137.504435,10.9924807 L128.731992,10.9924807 L128.731992,5.10631061 L137.853381,5.10631061 L137.853381,0.615814484 L123.770355,0.615814484 L123.770355,27.1356731 Z M157.506236,8.44247453 C157.506236,3.47442991 154.228214,0.615814484 148.499191,0.615814484 L141.131403,0.615814484 L141.131403,27.1356731 L146.098462,27.1356731 L146.098462,16.4770992 L146.748547,16.4770992 L153.615587,27.1356731 L159.723127,27.1356731 L151.702298,15.9646333 C155.448539,15.1666652 157.506236,12.5011231 157.506236,8.44247453 Z M147.543039,12.8220562 L146.098462,12.8220562 L146.098462,4.78589101 L147.62239,4.78589101 C150.721011,4.78589101 152.399697,6.14202595 152.399697,8.72284173 C152.399697,11.3853028 150.721011,12.8220562 147.543039,12.8220562 Z",
    id: "Shape",
    fill: "#0B1015",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.b8a3b0f4ad2cfbed7c2969447307911e.svg";
export { ForwardRef as ReactComponent };